import { Drawer } from '@mui/material';
import React from 'react';
import icons from '../constants/icons';
import { ReactSVG } from 'react-svg';
import images from '../constants/images';
import Text from './Text';
import { fontSizes } from '../constants/constants';
import dynamicfunction from '../utils/dynamicfunction';
import Language from './Language';
import Button from './Button';
import { tabsMenu } from '../config/config';
import { useLocation, useNavigate } from 'react-router';
import { cn } from '../utils/utils';
import ViewReverse from './ViewReverse';
import { clientSuspendedToast } from '../utils/functions';

const MobileMenu = ({ isDrawer, onClose, logoutText, onLogout, clientDetails, getContentKey, user, isCorporateForm, isIndividualForm }) => {
  const navigate = useNavigate();
  const pathname = useLocation();

  const { TextWeight, isArabic } = dynamicfunction();

  return (
    <Drawer open={isDrawer} onClose={onClose} anchor={isArabic ? "left" : 'right'}>
      <div className={`flex flex-col justify-between max-w-[300px] min-w-[300px] h-full bg-white p-4`}>
        <div>
          <ReactSVG src={icons.cross} className='cursor-pointer' onClick={onClose} />
          <ViewReverse className={'justify-between sm:justify-center items-center mt-3'}>
            <img src={images.logo} className='h-10' />
            <div className='block sm:hidden'>
              <Language isLogin />
            </div>
          </ViewReverse>

          <div className='h-10' />
          <div className='block sm:hidden'>
            <Text
              text={clientDetails?.clientInformation?.clientName ?? ''}
              color={'text-dark-grey'}
              className={'uppercase flex-1'}
              weight={TextWeight.regular}
              size={fontSizes.h17}
              isTruncate={false}
            />
            <Text text={clientDetails?.clientInformation?.clientEmail ?? ''} size={fontSizes.h11} />
          </div>
          {!user && !isCorporateForm && !isIndividualForm && (
            <ViewReverse className={'gap-3 items-center cursor-pointer block sm:hidden'} onClick={() => navigate('/help/faqs')} isReverse={false}>
              <ReactSVG src={icons?.Faqs_black_icon} />
              <Text text={getContentKey('faqs')} color={'text-black'} size={fontSizes.h15} />
            </ViewReverse>
          )}
          <div className='flex flex-col gap-4 mt-4'>

            {user && !isCorporateForm && !isIndividualForm && (
              tabsMenu(pathname?.pathname)?.map((item, index) => {
                const disabled = user ? false : true;
                const is_suspended = item?.key == 'cash_management' && user?.isClientSuspended;

                return (
                  <div
                    className={cn('rounded-md', item?.isActive ? 'bg-white' : 'bg-transparent', disabled && index !== 0 ? 'opacity-50 cursor-not-allowed' : 'opacity-100 cursor-pointer')}
                    onClick={() =>
                      !disabled && (
                        navigate(
                          `${is_suspended ? item?.suspended_route : item?.route}`
                        )
                      )
                    }
                    key={index}
                  >
                    <Text
                      text={getContentKey(item?.key)}
                      size={fontSizes.h14}
                      color={item?.isActive ? 'text-primary' : 'text-black'}
                    />
                  </div>
                )
              })
            )}
          </div>
        </div>
        <Button
          text={logoutText}
          bgColor='bg-transparent'
          color='text-black'
          className={'border border-grey w-28'}
          weight={TextWeight.regular}
          onClick={onLogout}
        />
      </div>
    </Drawer>
  );
};

export default MobileMenu;
